export default __webpack_public_path__ + "static/bourke-9a68a68077b747595c4dc529b0029f17.jpg";